<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Create Auction</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<!-- main row for all icons  -->
			<div class="col-md-12">
				<form @submit.prevent="addAuction" role="form">
				<div class="card card-primary card-outline">
					<div class="card-body">
						<div :class="['form-group', errors.auction_id ? 'has-error' : '']">
            	<label>Auction ID</label>
              <input type="number" name="auction_id" class="form-control" v-model="form.auction_id" placeholder="Enter the Auction ID" min="1">
              <span v-if="errors.auction_id" :class="['badge bg-danger']">Enter a valid auction ID.</span>
            </div>
            <div :class="['form-group', errors.name ? 'has-error' : '']">
             	 <label>Name</label>
               <input type="text" name="name" class="form-control" v-model="form.name" placeholder="Enter the Name">
               <span v-if="errors.name" :class="['badge bg-danger']">Enter a valid name.</span>
             </div>
             <div :class="['form-group', errors.description ? 'has-error' : '']">
             		<label>Description</label>
              	<input type="text" name="description" class="form-control" v-model="form.description" placeholder="Enter the Description">
              	<span v-if="errors.description" :class="['badge bg-danger']">Enter a valid description.</span>
             </div>
             <div :class="['form-group', errors.start_date ? 'has-error' : '']">
              	<label>Start Date</label>
                <input type="date" name="start_date" class="form-control" v-model="form.start_date" placeholder="Enter the Start Date">
                <span v-if="errors.start_date" :class="['badge bg-danger']">Enter a valid start date.</span>
              </div>
              <div :class="['form-group', errors.start_time ? 'has-error' : '']">
              	<label>Start Time</label>
                <input type="time" name="start_time" class="form-control" v-model="form.start_time" placeholder="Enter the Start Time">
                <span v-if="errors.start_time" :class="['badge bg-danger']">Enter a valid start time.</span>
              </div>
              <div :class="['form-group', errors.end_date ? 'has-error' : '']">
              	<label>End Date</label>
                <input type="date" name="end_date" class="form-control" v-model="form.end_date" placeholder="Enter the End Date">
                <span v-if="errors.end_date" :class="['badge bg-danger']">Enter a valid end date.</span>
              </div>
              <div :class="['form-group', errors.end_time ? 'has-error' : '']">
              	<label>End Time</label>
                <input type="time" name="end_time" class="form-control" v-model="form.end_time" placeholder="Enter the End Time">
                <span v-if="errors.end_time" :class="['badge bg-danger']">Enter a valid end time.</span>
              </div>
					</div>
					<div class="card-footer">
					<button class="btn btn-primary" type="submit">Submit</button>
				</div>
				</div>
				
				</form>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    <br>
      <br>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAuctionManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        data(){
        	return {
        		form: new Form({
        			auction_id: '',
        			name: '',
        			description: '',
        			start_date: '',
        			start_time: '',
        			end_date: '',
        			end_time: '',
        			created_by: this.$userId,
        			updated_by: this.$userId,
        			id: ''
        		}),
        		errors: []
        	}
        },
        
        methods: {
        	addAuction(){
        		this.form.post("/api/addAuction")
        		.then(()=>{
      	     		toast.fire({
      		      	type: 'success',
                	title: 'Auction Added'
            		});
            		this.errors = [];
    				})
    				.catch((error)=>{
            	toast.fire({
      	      	type: 'error',
              	title: 'Adding Failed'
            	}); 
            	this.errors = error.response.data.errors;  
          	})
        	}
        }
    }
</script>
